import React from "react";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Form, Col, InputNumber } from "antd";
import { BOM } from "../../../../services/definedMethod";

const { Text } = Typography;

export const TermsForm = (props) => {
  const { fixedDepositDetails } = props;

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        padding: 10,
      }}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Default Deposit Amount</Text>}>
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              placeholder="Not set"
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails.depositAmount ?? null}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Minimum Deposit Amount</Text>}>
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              placeholder="Not set"
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails.minDepositAmount ?? null}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Maximum Deposit Amount</Text>}
            rules={[{ required: true, message: "Required Field" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              placeholder="Not set"
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails.maxDepositAmount ?? null}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Interest Compounding Period</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails.interestCompoundingPeriodType.value}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Interest Posting Period</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails.interestPostingPeriodType.value}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Interest Calculated Using</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails.interestCalculationType.value}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Days In Year</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={
                fixedDepositDetails.interestCalculationDaysInYearType.value
              }
            />
          </Form.Item>
        </Col>
      </Row>
      {/* </Form> */}
    </Card>
  );
};
